import React from 'react';
import { Modal, Tabs, Tab } from "react-bootstrap";
import PDFPrinting from '../containers/PDFPrinting';
import FRAReportPinting from '../containers/FRAReportPinting';
import {constants} from '../containers/common/commonExport';
import apiConst from '../../../constants/const'

const ActivityModal = (props) => {
    let isImpersnateCertify = props.authDetails.impersonateUserId>0 && apiConst.isImpersonateEditAllow && 
        (props.workday.AllowAmendmentEdit == '0' || props.workday.AllowAmendmentEdit == undefined );

    let isCertified = (props.workday && props.workday.wdy_certify_status != undefined && props.workday.wdy_certify_status.trim().toUpperCase() === 'C') 

    let enableCertifyButton = !(props.workday.AllowAmendmentEdit == '0' || props.workday.AllowAmendmentEdit == undefined) && props.isEdit;
    let isAdminCertify = (props.authDetails.isSystemAdmin != undefined && props.authDetails.isSystemAdmin==true)
    

    return (
        <Modal show={ props.showModal && (props.modalName == constants.hosModals.Certify_Modal)}
            onHide={props.onHideModal()} className="activityModalContainer"
            bsSize="large" aria-labelledby="contained-modal-title-lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    {
                        props.isLogUser ? 
                        <div style={{textAlign : "center",fontWeight:"bold"}}>
                            <span> Logs </span>
                            <br />
                            <span> Service Date {props.getWorkdayDate || props.workday.wdy_date} </span>
                            <br />
                        </div>    
                        : 
                        <span className="activity-header"> {props.modalTitle} </span>
                    }
                    {props.isLogUser != true && (
                        <PDFPrinting hidden = {false} Page="Projects" data = {props.workday.duty_activity} compTitle = {props.modalTitle} isLoading= {props.isLoading} validWorkday={props.validWorkday} />
                    )}
                    {localStorage.getItem('route') == constants.FRA_REPORT && (
                        <FRAReportPinting Page="FRA Report" hidden={props.isLoading} isSelectedData={false} />
                    )}
                    <button className={"pull-right btn btn-primary btnWidth btnPrimaryColor editActivityButton " + ((isImpersnateCertify && !isAdminCertify)? "hidden" : props.isViewMode && !props.authDetails.impersonateUserId>0 ? "hidden" : props.showErr ? 
                        ((props.showEditActivityButton && props.validWorkday) || (props.authDetails.impersonateUserId>0 && apiConst.isImpersonateEditAllow)  ? '':'hidden') : 'hidden')} 
                        onClick={props.onEditAllActivity()}>
                        {
                            props.isLogUser && props.workday.AllowAmendmentEdit == '1' && isCertified ? 'Amend' : 'Edit'
                        }
                    </button>
                 
                </Modal.Title>
                
            </Modal.Header>
            
            <div className={!props.activityErrPopup ? ( "animated fadeOut hidden" ) : (
                                "animated fadeIn errAlertDiv alert alert-danger fade in alert-dismissable"
                    )}>
                <a className="close" onClick={props.oncloseErrPop()} data-dismiss="alert"
                    aria-label="close" title="close" >×</a>
                <strong>{props.latestRecords ? 'Error' : 'Warning'}!</strong> {props.activityErrMessage}
            </div>
            <div className={props.workday.shiftTimeMessage && props.isViewMode && !props.authDetails.impersonateUserId>0 && !props.activityErrPopup ?"errAlertDiv alert alert-danger fade in":"hidden"}>
                {props.workday.shiftTimeMessage}
            </div>      
            
    
            <div className={props.isEdit && props.isLogUser && props.workday.AllowAmendmentEdit == '1' && isCertified && !props.changesInActivity?  (
                                "animated fadeIn errAlertDiv alert alert-danger fade in alert-dismissable"
                    ):( "animated fadeOut hidden" ) }>
                <a className="close" onClick={props.oncloseErrPop()} data-dismiss="alert"
                    aria-label="close" title="close" >×</a>
                <strong>{'Warning'}!</strong> {"- To submit an amendment, you must make changes to the record."}
            </div>
            

            
            <Modal.Body>
                {
                    props.isLogUser ?
                    <div className="activityModal content-border">{props.renderCertifyModal(props.defaultWorkday)}</div>
                    :
                    <Tabs id="tabs" activeKey={props.isEdit ? props.eventKey == 1 ? props.eventKey+1 : props.eventKey  : props.eventKey}
                        onSelect={props.handleTabChange()} >
                        <Tab eventKey={1} title="Summary" disabled={props.isEdit }>
                            <div className="activityModal content-border">{props.renderCertifyModal(props.defaultWorkday)}</div>                
                        </Tab>
                        <Tab eventKey={2} title="Details">
                            <div className="activityModal content-border">{props.renderCertifyModal(props.defaultWorkday)}</div>
                        </Tab>
                        <Tab eventKey={3} title="E&D">
                            {props.renderEnDTab()}
                        </Tab>
                    </Tabs>
                }
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <button className={"activitiesCancelBtn " + (!props.changesInActivity ? "hidden" : "btn btn-primary btnWidth btnPrimaryColor")}
                        onClick={props.onCancelActivityModal}> Cancel
                    </button>
                    <p className={"certifyIssue " + (props.showErr ? ((props.validWorkday || props.validWorkday == undefined || props.islogAdmin) ? 'hidden' : '') : 'hidden')}>
                        {constants.errMessages.recordCannotCertify}
                    </p> 
                    <button className={"btn btn-primary amendBtnWidth btnPrimaryColor " + ((isImpersnateCertify && !isAdminCertify) ? "hidden" : props.isViewMode && !props.authDetails.impersonateUserId>0 ? "hidden" : (props.authDetails.impersonateUserId>0 && apiConst.isImpersonateEditAllow) ? "" : props.isLoading ? 'hidden' : props.validWorkday || props.validWorkday == undefined ? (props.isLogUser && props.workday.AllowAmendmentEdit == '0') || props.islogAdmin ? 'hidden' : '' : 'hidden')}
                        disabled={props.certifyError || props.activityErr || (!props.changesInActivity && props.isLogUser && (!enableCertifyButton || isCertified))}
                        onClick={() => { props.onCertify(false)}}>
                        {
                            props.isLogUser && props.workday.AllowAmendmentEdit == '1' && isCertified ? 'Submit Amend' : 'Certify'
                        }
                    </button> 
                    <button className={"btn btn-primary amendBtnWidth btnPrimaryColor " + ((isImpersnateCertify && !isAdminCertify) ? "hidden" : props.isViewMode && !props.authDetails.impersonateUserId > 0 ?
                        "hidden" :
                        (props.authDetails.impersonateUserId > 0 && apiConst.isImpersonateEditAllow && !props.workday.AllowAmendmentEdit == '1' ) ? "" : props.isLoading ? 'hidden' : props.validWorkday || props.validWorkday == undefined ? (props.isLogUser && props.workday.AllowAmendmentEdit == '0') || props.islogAdmin || !props.isLogUser || isCertified ? 'hidden' : '' : 'hidden')}
                        disabled={props.certifyError || props.activityErr || !props.changesInActivity}
                        onClick={() => props.onCertify(true)}>
                        {
                             'Save' 
                        }
                    </button> 
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default ActivityModal;
